export function getEnvironmentId() {
  return "scaler"
}

export function getEnvironmentMode() {
  return process.env.NODE_ENV
}

export function isDevelopment() {
  return getEnvironmentMode() === "development"
}
